module.exports = __webpack_public_path__ + "img/dots_ltp4.8869c5fc.png";